<template>
    <div>
        <pagination-component
            :pagination="pagination"
            :key="'pagination-1-'+ (pagination.current_page ? pagination.current_page : 1) + pagination.total"
        ></pagination-component>
        <table class="table simple-table table-striped table-sm mb-0 table-bordered" style="font-size:0.8em;">
            <thead class="thead-dark">
            <tr>
                <th class="report-record" scope="col">{{$lang('ID')}}</th>
                <th class="report-record" scope="col">{{$lang('Zgłaszający')}}</th>
                <th class="report-record" scope="col">{{$lang('Temat')}}</th>
                <th class="report-record" scope="col">{{$lang('Data zgłoszenia')}}</th>
                <th class="report-record" scope="col">{{$lang('Data oceny')}}</th>
                <th class="report-record" scope="col">{{$lang('Czas reakcji')}}</th>
                <th class="report-record" scope="col">{{$lang('Data realizacji')}}</th>
                <th class="report-record" scope="col">{{$lang('Status')}}</th>
                <th class="report-record" scope="col">{{$lang('Czas rozwiązania')}}</th>
            </tr>
            </thead>
            <tbody>

            <tr v-if="pagination.total === 0" class="table-light">
                <th colspan="9">{{$lang('Brak zgłoszeń.')}}</th>
            </tr>

            <template v-else v-for="(task, index) in pagination.data">

                <tr v-if="index%50 === 0 || task.criterion !== pagination.data[index-1].criterion">
                    <th colspan="9">
                        <div class="form-row">
                            <div class="col-3">{{task.criterionName}}</div>
                        </div>
                    </th>
                </tr>

                <tr>
                    <td class="report-record" :data-title="$lang('ID')"><a :href="'/task/' + task.id" target="_blank">{{task.id}}</a>
                    </td>
                    <td class="report-record text-left"
                        :data-title="$lang('Zgłaszający')">{{task.notifier}}
                    </td>
                    <td class="report-record text-left"
                        :data-title="$lang('Temat')">{{task.subject}}
                    </td>
                    <td class="report-record"
                        :data-title="$lang('Data zgłoszenia')">{{task.created_at_showable}}
                    </td>
                    <td class="report-record"
                        :data-title="$lang('Data oceny')">{{task.evaluate_date_showable}}
                    </td>
                    <td class="report-record"
                        :data-title="$lang('Czas reakcji')" v-if="showTimeColumn(task.criterion)">{{task.reactionTime}}
                    </td>
                    <td class="report-record"
                        :data-title="$lang('Data realizacji')" v-if="showTimeColumn(task.criterion)">{{task.implementation_date_showable}}
                    </td>
                    <td class="report-record" :colspan="statusColspans[task.id]"
                        :data-title="$lang('Status')">
                        <span :class="'badge badge-'+project_badge_prefix+task.status">{{task.statusName}}</span>
                    </td>
                    <td class="report-record"
                        :data-title="$lang('Czas rozwiązania')" v-if="showTimeColumn(task.criterion)">{{task.resolveTime}}
                    </td>
                </tr>

            </template>

            <template v-if="pagination.current_page===pagination.last_page" v-for="(criterion) in criteriaWithoutTasks">
                <tr>
                    <th colspan="9">
                        <div class="form-row">
                            <div class="col-3">{{criterion.name}}</div>
                            <div>{{$lang('BRAK')}}</div>
                        </div>
                    </th>
                </tr>
            </template>

            </tbody>
        </table>

        <pagination-component
            :pagination="pagination"
            :key="'pagination-2-'+ (pagination.current_page ? pagination.current_page : 1) + pagination.total"
        ></pagination-component>
    </div>
</template>

<script>
export default {
    name: "maintenance-service-summary-table",
    props: {
        pagination: Object,
        countTimeForAll: String,
        criteriaWithoutTasks: Array,
        project_badge_prefix: String,
    },
    data() {
        return {
            statusColspan: 0,
        }
    },
    methods: {
        showTimeColumn(criterionId) {
            return this.countTimeForAll === '1' || (parseInt(criterionId) >= 19 && parseInt(criterionId) <= 21);
        }
    },
    computed: {
        statusColspans() {
            const statusColspans = [];
            for (const taskId in this.pagination.data) {
                if (this.countTimeForAll === '1' || (parseInt(this.pagination.data[taskId].criterion) >= 19 && parseInt(this.pagination.data[taskId].criterion) <= 21)) {
                    statusColspans[parseInt(this.pagination.data[taskId].id)] = 1;
                } else {
                    statusColspans[parseInt(this.pagination.data[taskId].id)] = 4;
                }
            }
            return statusColspans;
        }
    }
}
</script>

<style scoped>

</style>
